import React from "react";
import "./Info.css";
import { AppModal } from "../Modals/TextAreaModal";
import FadeIn from "react-fade-in";

class Info extends React.Component {
  constructor(props) {
    super(props);

    //State storage - now loads from database via API

    this.state = {
      infoPage: null,
      title: "Praktisk info",
      sections: [],
      showModal: false,
      auth: false,
      error: false
    };

    //Bindings
    this.changePost = this.changePost.bind(this);
    this.cancelPost = this.cancelPost.bind(this);
    this.savePost = this.savePost.bind(this);
    this.modalPop = this.modalPop.bind(this);
    this.getInfoPage = this.getInfoPage.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.getInfoPage();
  }

  async getInfoPage() {
    try {
      const response = await fetch("/api/pagedata/getInfoPage", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          pragma: "no-cache",
          "cache-control": "no-cache"
        }
      });

      const data = await response.json();
      if (data && data.length > 0 && data[0]) {
        this.setState({
          infoPage: data[0],
          title: data[0].title || "Praktisk info",
          sections: data[0].sections || this.getDefaultSections(),
          error: false
        });
      } else {
        // Fallback to default content if no database content exists
        this.setState({
          infoPage: {},
          title: "Praktisk info",
          sections: this.getDefaultSections(),
          error: false
        });
      }
    } catch (err) {
      console.log(err);
      this.setState({ error: true });
    }
  }

  getDefaultSections() {
    return [
      {
        id: 1,
        title: "Regler",
        content: "<br><br> <ul style='text-align:left;'><li>GAMERLAN er et rusfritt arrangement. Brudd på dette vil føre til umiddelbar utestengelse </li><li>Nødutganger skal ikke blokkeres under noen omstendigheter</li><li>Tyveri, hærverk, mobbing osv. blir politianmeldt</li><li>Høytalere er forbudt</li><li>Inngangsbånd skal være på under hele arrangementet</li><li>Soving skal skje i våre sovesoner. Er du i tvil om hvor du kan sove, spør crew</li><li>Vi tillater ikke bruk av hyller på plassene</li><li>Bruk av sparkesykler, ståhjulinger, radiostyrte biler osv. innendørs er ikke tillatt</li><li>GAMERLAN erstatter ikke eventuelt tap av utstyr</li><li>Vi kan refundere forhåndspåmeldinger inntil 48 timer før påmeldingen stenger</li><li>Ved brudd på disse regelene forbeholder vi oss retten til å bortvise</li><li>Vi forbeholder oss retten til å endre på regelene til enhver tid</li><li>GAMERLAN er et offentlig arrangement</li><li>Kjøps og salgsbetingelser finner du <a href='http://www.gamerlan.no/betingelser'>HER</a></li></ul>",
        order: 1
      },
      {
        id: 2,
        title: "Praktisk Informasjon",
        content: "<br> <br> <ul style='text-align:left;'> <b>HVA BØR DU HA MED? </b> <li>Bordplassen du får tildelt er ca 80cm bred. Dette tilsvarer bredden til en 37″ TV </li> <li> Samtykkeskjema om du er under 16 år, skjemaet finner du <a href='/__public/samtykkeskjema.pdf' target='blank'>HER</a> </li> <li>PC/Xbox/Playstation/Nintendo</li> <li>En minimum 5 meter lang nettverkskabel</li Om du glemmer nettverkskabel, tilbyr vi salg av kabler så lenge lageret rekker </li> <li>Strømkabel, skjermkabel, strømpadde</li> <li>Mus, tastatur og musematte </li> <li>Hodetelefoner. Vi tillater ikke eksterne høytalere</li> <li>Nettverkskort. Vi tilbyr trådløst, men kan ikke garantere stabiliteten i et rom med 50 - 100 deltakere</li> <li>Du får bare en nettverksport, ta med deg en switch om du skal koble opp flere enheter</li><li>Vi har stol du kan låne, men vær obs på at dette er typiske plaststoler som vi låner fra skolen</li> <li>Minnepenner er kjekt å ha på LAN</li> <li>Søppelposer - vi setter pris på at du holder det ryddig rundt deg</li> <li>Mobiltelefon med lader</li> <li>Penger - hvis du skal kjøpe mat på GAMERLAN <b>(VI TAR VIPPS OG KONTANTER, MEN IKKE BANKKORT)</b></li> <li>Superviktig! Tannbørste, barbersaker, deodorant og såpe</li> <li>Sovepose, pute og liggeunderlag (NB. Oppblåsbare dobbeltsenger anbefales ikke, de tar mye plass)</li> <li>Klesskift / Rene klær</li> <li>Alle medikamenter du måtte trenge i løpet av helgen. Du bør alltid ha på deg evt. nødvendig medisinsk dokumentasjon</li> <br> <b>MAT</b> <li>Vi anbefaler at du kjøper noen brødskiver og pålegg (syltetøy på tube, ferdigoppskjært ost, etc). </li>  <li>Det finnes Matbutikker i nærheten, nærmeste er Kiwi ca. 350 Meter unna</li> <br> <b>TING DU IKKE TRENGER</b> <li>Kjøleskap</li> <li>Mikrobølgeovn</li> <li>Vannkoker</li> <li>Høyttalere</li> <li>Andre apparater som trekker mye strøm</li> <br> <br> <b>HUSK AT DETTE ER ET 100% RUSFRITT ARRANGEMENT</b> </ul>",
        order: 2
      },
      {
        id: 3,
        title: "Om påmelding",
        content: "<br> <br> <ul style='text-align:left;'><li>Forhåndspåmeldinger betales kun med Vipps</li> <li>Har du ikke mulighet til å betale med Vipps må du dessverre satse på at det er ledige plasser ved oppmøte, og betale kontant</li> <li>Betalingsfristen er 3 døgn fra påmelding</li> <li>Hvis betalingen ikke er mottatt innen fristen vil reservasjonen din slettes</li><li>Ved gjentatte påmeldinger uten betaling kan du blokkeres fra videre påmeldingsforsøk</li> <li>Du kan ta kontakt med oss for å refundere en påmelding inntil 48 timer før påmeldingen stenger</li> <li>Påmeldingen stenges noen dager før LAN. Be oss om refusjon senest en uke før, for å være sikker</li> <li>Betalingsinformasjon får du tilsendt på mail etter påmeldingen er fullført</li> <li>Som nevnt i mailen er det viktig at du skriver inn din unike kode som kommentar på Vipps-betalingen</li> <li>For informasjon om hvordan du kan betale i Vipps, trykk <a href='http://www.gamerlan.no/betaling'>HER</a></li><li>GAMERLAN drives 100% frivillig og alle pengene går tilbake inn i arrangementet</li><li>Vi setter dermed stor pris på om påmeldinger kan betales innen fristen, slik at vi ikke trenger å bruke fritiden på å sende ut purringer osv. :)</li></ul>",
        order: 3
      }
    ];
  }

  changePost(newPost) {
    //Takes an event param, done automatically by eventhandler - see AppModal for handleChange
    this.setState({ post: newPost }); //Updates the state with new value
  }

  //Event for modal cancel button, sets Post state back to onLoadPost
  cancelPost(cancel) {
    this.setState({ post: this.state.onLoadPost });
    this.setState({ showModal: false });
  }
  //Event for modal save button, will push to DB, needs logic implementation
  savePost(newPost) {
    //Implement logic for saving post and refreshing the content
    console.log("saved the post");
    this.setState({ onLoadPost: newPost });
  }

  modalPop(e) {
    //Trigger App's modal component... Toggles showModal true or false
    if (this.state.showModal === false) {
      this.setState({ showModal: true });
    } else {
      this.setState({ showModal: false });
    }
  }

  render() {
    return (
      <FadeIn>
        <div className="Info">
          <div className="col-md-10 col-centered">
            <div className="infoCard">
              <h1 style={{ color: "white", marginBottom: "0" }}>{this.state.title}</h1>
            </div>
            {this.state.sections
              .sort((a, b) => a.order - b.order)
              .map((section) => (
                <div key={section.id} className="infoCard">
                  <div dangerouslySetInnerHTML={{ __html: section.title }} />
                  <div dangerouslySetInnerHTML={{ __html: section.content }} />
                </div>
              ))}
            {this.state.auth === true && (
              <button className="btn btno btn-info" onClick={this.modalPop}>
                {" "}
                Modal{" "}
              </button>
            )}
            {this.state.showModal === true && (
              <AppModal
                post={this.state.post || ""}
                onLoadPost={this.state.onLoadPost || ""}
                onChange={this.changePost}
                cancelPost={this.cancelPost}
                savePost={this.savePost}
                showModal={this.state.showModal}
              />
            )}
          </div>
        </div>
      </FadeIn>
    );
  }
}

export default Info;



// WEBPACK FOOTER //
// ./src/Components/Info/Info.js